export default __webpack_public_path__ + "static/media/7minfitness_1@2x.0876dbc4.jpg";